import { authHeader } from '../_helpers';
import { handleResponse } from '../_helpers';
import { apiClient } from '../_helpers';

export const brandService = {
  getAll,
  getSelectList,
  searchBrands,
  getById,
  addBrand,
  updateBrand,
  deleteBrand,
  getCurrentBrand
};

function getAll(params) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
};

  var ps = "";
  var ccat = "";
  if(params && params.query)
  {
    ps = ps + "searchQuery=" + params.query;
    ccat = "&";
  }
  if(params && params.filter)
  { 
    ps = ps + ccat + "filter=" + params.filter;
    ccat = "&";
  }
  if(params && params.pageSize)
  { 
    ps = ps + ccat + "pageSize=" + params.pageSize;
    ccat = "&";
  }
  if(params && params.page)
  {
    ps = ps + ccat + "pageNumber=" + params.page;
    ccat = "&";
  }
  if(params && params.dataTypes)
  {
    for (var i = 0; i < params.dataTypes.length; i++) { 
      ps = ps + ccat + "dataTypes=" + params.dataTypes[i];
      ccat = "&";
    }
  }

  return fetch(`${process.env.VUE_APP_API_HOSTNAME}/api/brands?${ps}`, requestOptions).then(handleResponse);
}

function getSelectList() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
};

  return fetch(`${process.env.VUE_APP_API_HOSTNAME}/api/brands/selectlist`, requestOptions).then(handleResponse);
}

function searchBrands(qry) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };

  return fetch(`${process.env.VUE_APP_API_HOSTNAME}/api/brands?searchQuery=${qry}`, requestOptions).then(handleResponse);
}

function getById(id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
};

  return fetch(`${process.env.VUE_APP_API_HOSTNAME}/api/brands/${id}`, requestOptions).then(handleResponse);
}
function addBrand(newBrand) {
  return apiClient('brands/')
  .post('',`${JSON.stringify(newBrand)}`)
  .then(response => {
    return response.data;
  })
  .catch(error => {
    return error;
  });
}
function updateBrand(brand) {
  return apiClient(`brands/${brand.id}`)
  .put('',`${JSON.stringify(brand)}`)
  .then(response => {
    return response.data;
  })
  .catch(error => {
    return error;
  });
}
function deleteBrand(brand) {
  return apiClient(`brands/${brand}`)
  .delete()
  .then(response => {
    return response.data;
  })
  .catch(error => {
    return error;
  });
}
function getCurrentBrand(brandSlug) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };
  return fetch(`${process.env.VUE_APP_API_HOSTNAME}/api/brands/${brandSlug}`, requestOptions)
    .then(handleResponse)
    .then(brand => {
        return brand;
    });
}